module.exports = __webpack_public_path__ + "6ac71106919b10dd1de13fa771d01e91.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/GC_PUBLIKUM.jpg
// module id = 617
// module chunks = 0